// src/api/axiosInstance.js
import axios from "axios";

const api = axios.create({
  baseURL: "https://api.ctrl-plusx.com/api/",//"http://localhost:8080/api", 
  withCredentials: true, 
});
  
// ✅ Attach access token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// ✅ Handle expired access token
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (!error.response) return Promise.reject(error);
 
    // Only retry once
    if ((error.response.status === 401 || error.response.status === 403) && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshRes = await api.get("/users/refresh", { withCredentials: true });
        const newAccessToken = refreshRes.data.accessToken; 

        localStorage.setItem("accessToken", newAccessToken);

        originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
        return api(originalRequest);
      } catch (refreshError) {
        localStorage.removeItem("accessToken");
        localStorage.removeItem("user");
        // optionally redirect to login page
        // window.location.href = "/login";
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;